import React from 'react';
import { Box, Stack } from '@mui/material';
import { ArrowDropUp, ArrowDropDown } from '@mui/icons-material';
import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined';
import makeStyles from '@mui/styles/makeStyles';
import PropTypes from 'prop-types';
import i18n from 'i18next';

const useStyles = makeStyles((theme) => ({
    root: {},
    header: {
        position: 'relative',
        background: theme.palette.documentViewer.timelineItemBackgroundColor,
        borderRadius: '8px',
        padding: '10px',
    },
    groupName: {
        color: theme.palette.documentViewer.contrastTextColor,
        fontFamily: 'Inter',
        fontSize: '16px',
        fontStyle: 'normal',
        fontWeight: '600',
    },
    attachment: {
        fontWeight: 500,
        '& svg': {
            height: '21px',
            verticalAlign: 'text-bottom',
        },
    },
    groupDate: {
        color: theme.palette.documentViewer.lowContrastTextColor,
        fontFamily: 'Inter',
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: '400',
    },
    groupBox: {
        height: '24px',
        minWidth: '24px',
        borderRadius: '4px',
        padding: '3px',
        textAlign: 'center',
        fontSize: '16px',
        fontWeight: '600',
        lineHeight: '16px',
    },
    collapseSwitch: {
        height: '24px',
        cursor: 'pointer',
    },
}));

export default function EpisodeGroup(props) {
    const classes = useStyles();
    const [spellExpanded, setSpellExpanded] = React.useState(props.defaultExpanded);

    return (
        <Stack direction={'column'} className={`${classes.root}`} gap={'6px'} paddingY={'10px'}>
            <Box className={classes.header}>
                <Stack direction={'row'} justifyContent={'space-between'} alignItems={'top'}>
                    <Stack direction={'column'} paddingBottom={'10px'}>
                        <Stack direction={'row'} gap={'12px'} alignItems={'center'}>
                            <Box className={classes.groupBox} style={{ background: props.color }}>
                                {props.short}
                            </Box>
                            <Box className={classes.groupName}>{props.name}</Box>
                            {props.showAttachCount && (
                                <Box className={classes.attachment}>
                                    <AttachFileOutlinedIcon fontSize={'16px'} />
                                    {props.children.length}
                                </Box>
                            )}
                        </Stack>
                        <Box className={classes.groupDate}>{`(${props.startDate} - ${props.endDate})`}</Box>
                    </Stack>
                    <Box className={classes.collapseSwitch} onClick={() => setSpellExpanded(!spellExpanded)}>
                        {spellExpanded ? <ArrowDropUp /> : <ArrowDropDown />}
                    </Box>
                </Stack>
            </Box>
            {spellExpanded && props.children}
        </Stack>
    );
}

EpisodeGroup.defaultProps = {
    name: '-',
    short: 'X',
    color: '#2180F7',
    startDate: i18n.t('Not Set', 'Not Set') !== undefined ? i18n.t('Not Set', 'Not Set') : 'Not Set',
    endDate: i18n.t('Outgoing', 'Outgoing') !== undefined ? i18n.t('Outgoing', 'Outgoing') : 'Outgoing',
    defaultExpanded: true,
    showAttachCount: false,
};

EpisodeGroup.propTypes = {
    name: PropTypes.string,
    short: PropTypes.string,
    color: PropTypes.string,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    defaultExpanded: PropTypes.bool,
    showAttachCount: PropTypes.bool,
};
